import React, { Component } from "react";

export default class TxtViewerClass extends Component {
parseTimedText(input) {
  const lines = input.split(/\r?\n/);
  const result = [];
  const timecodeRegex = /^(\d{2}:\d{2}:\d{2}[.:]\d{2,3})\s*(.*)$/;

  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed) continue; // ignorer lignes vides

    const match = trimmed.match(timecodeRegex);
    if (match) {
      result.push({
        timecode: match[1],
        text: match[2].trim() || null
      });
    } else {
      result.push({
        timecode: null,
        text: trimmed
      });
    }
  }

  return result;
}

  render() {
    const { text } = this.props;
    const subtitles = this.parseTimedText(text);

    const containerStyle = {
      background: "#0d1117",
      color: "#c9d1d9",
      padding: "1rem",
      borderRadius: "0.75rem",
      fontFamily: "JetBrains Mono, Fira Code, monospace",
      lineHeight: "1.5em",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
    };

    const timeStyle = { color: "#58a6ff", fontWeight: "bold" , lineHeight: "1em",};
    const textStyle = { color: "#dcdcdc", whiteSpace: "pre-line" }; // <-- conserve les \n visuellement

    return (
      <div style={containerStyle}>
        {subtitles.map((sub, i) => (
          <div key={i} style={{ marginBottom: "0.75rem" }}>
            <div style={timeStyle}>{sub.timecode}</div>
            <div style={textStyle}>{sub.text}</div>
          </div>
        ))}
      </div>
    );
  }
}
